import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogCardPickerComponent } from "./dialog-card-picker.component";
import { SharedModules } from "../../shared.modules";
import { CardModule } from "../../common/card/card.module";
import { PipesModule } from "../pipes/pipes.module";
import { DialogDefaultModalComponent } from "../dialog-default-modal/dialog-default-modal.component";
import { AngularSvgIconModule } from "angular-svg-icon";
import { ButtonComponent } from "../button/button.component";
import { CardFilter2Pipe } from "../pipes/card-filter-2.pipe";
import { WavySectionModule } from "../wavy-section/wavy-section.module";
@NgModule({
  declarations: [DialogCardPickerComponent],
  exports: [DialogCardPickerComponent],
  imports: [
    CommonModule,
    SharedModules,
    CardModule,
    PipesModule,
    DialogDefaultModalComponent,
    AngularSvgIconModule,
    ButtonComponent,
    WavySectionModule,
  ],
  providers: [CardFilter2Pipe],
})
export class DialogCardPickerModule {}
